<template lang="html">
  <div class="recommend">
    <div v-for="a in recommendList" :key="a.renovation_block_id">
      
      <div class="typeOneCon">
        <!-- 视频 -->
        <div v-if="a.type == 1 && a.person_block_data != ''" class="videoMod">
          <p class="modTitle">{{a.name}}</p>
          <div class="videoDetails">
            <div class="videoCon" v-for="(b, index) in a.person_block_data" :key="index" @click="goVideo(b.unique_id, b.type)">
              <div class="videoTV" :style="{backgroundImage: 'url('+ b.pic +')'}">
                <p class="videoTitle">{{b.title}}</p>
                <img src="../../../assets/image/icon/playBtn.png" alt="" class="playBtn">
              </div>
              <div class="videoNum">
                <div class="iconBtn">
                  <img src="../../../assets/image/icon/browse.png" alt="">
                  <p>{{b.view_number}}</p>
                </div>
                <div class="iconBtn">
                  <img src="../../../assets/image/icon/reply.png" alt="">
                  <p>{{b.comment_number}}</p>
                </div>
                <div class="iconBtn">
                  <img src="../../../assets/image/icon/praise.png" alt="">
                  <p>{{b.like_number}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 产品 -->
        <div v-if="a.type == 2 && a.person_block_data != ''" class="productMod">
          <p class="modTitle">{{a.name}}</p>
          <div class="productDetails">
            <div v-for="(c, index) in a.person_block_data" :key="index" class="productContent" @click="goProduct(c.id)">
              <img :src="c.cover" alt="" class="productCover">
              <div class="productTitle"><span v-show="c.recommended_index > 0">置顶</span>{{c.product_name}}</div>
              <div class="productInfo">
                <p class="productPrice" v-if="c.reference_price"><span>￥</span>{{c.reference_price}}<span>参考价</span></p>
                <p class="productPrice" v-else><span>暂无参考价</span></p>
                <p class="productView">
                  <img src="@/assets/image/icon/browse.png" alt="">
                  <span>{{c.view_number}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 课程 -->
        <div v-if="a.type == 3 && a.person_block_data != ''" class="courseMod">
          <p class="modTitle">{{a.name}}</p>
          <div class="videoDetails">
            <div class="videoCon" v-for="(d, index) in a.person_block_data" :key="index" @click="goCourse(d.courseid)">
              <div class="videoTV" :style="{backgroundImage: 'url('+ d.pic +')'}">
                <p class="videoTitle" v-html="d.summary"></p>
                <img src="../../../assets/image/icon/playBtn.png" alt="" class="playBtn">
              </div>
              
              <div class="courseCon">
                <p class="courseTitle">{{d.title}}</p>
                <div class="courseTeacher">
                  <div class="teacherHeadPortrait" >
                    <img v-for="i in d.teacher" :src="i.avatar" alt="" :key="i.uid">
                  </div>
                  <div class="priceBtn" v-if="d.price <= 0"> 免费 </div>
                  <div class="priceBtn" v-else> {{d.price}}巢币 </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 论坛、话题、留言板 -->
      <div v-if="a.type == 4 && a.person_block_data != ''" class="elseMod">
        <p class="modTitle">{{a.person_block_info.name}}</p>
        <div v-for="(e, index) in a.person_block_data" :key="index" class="content" >
          <div class="cardMod" v-if="e.source_type == 2" @click="goTopic(e.origin_resource_id)">
            <div class="userName">
              <div class="userImg">
                <img :src="e.avatar" alt="" class="userHeadPortrait">
                <img src="@/assets/image/icon/pv.png" alt="" class="userMark" v-if="e.mp_type == 1">
                <img src="@/assets/image/icon/tv.png" alt="" class="userMark" v-if="e.mp_type == 2">
              </div>
              <p>
                <span>{{e.username}}</span>
                <span>·</span>
                <span>
                  发布的话题
                </span>
              </p>
            </div>
            <div v-if="e.images.length > 0" class="titleModel">
              <div>
                <p class="userTitle">{{e.title}}</p>
              </div>
              <img :src="e.images[0]" alt="">
            </div>
            <div v-else class="elseTitleModel">
              <p class="userTitle">{{e.title}}</p>
            </div>

            <div class="timeModel">
              <p class="userTime">{{e.date}}</p>
              <div class="hotModel">
                <div class="hotModelChild">
                  <p class="hotNum">{{e.concerns_number}}</p>
                  <p class="hotTxt">关注</p>
                </div>
                <div class="hotModelChild">
                  <p class="hotNum">{{e.joinnumber}}</p>
                  <p class="hotTxt">参与</p>
                </div>
              </div>
            </div>
          </div>

          <div class="cardMod" v-if="e.source_type == 3" @click="goTopicPost(e.origin_resource_id)">
            <p class="userTitle">{{e.title}}</p>
            <div class="userName">
              <div class="userImg">
                <img :src="e.avatar" alt="" class="userHeadPortrait">
                <img src="@/assets/image/icon/pv.png" alt="" class="userMark" v-if="e.mp_type == 1">
                <img src="@/assets/image/icon/tv.png" alt="" class="userMark" v-if="e.mp_type == 2">
              </div>
              <p>
                <span>{{e.username}}</span>
                <span>·</span>
                <span>
                  参与的话题
                </span>
              </p>
            </div>
            <div v-if="e.images.length > 0" class="titleModel">
              <div>
                <p class="userContent" v-html="srtText(e.content)"></p>
              </div>
              <img :src="e.images[0]" alt="">
            </div>
            <div v-else class="elseTitleModel">
              <p class="userContent" v-html="srtText(e.content)"></p>
            </div>
            <div class="timeModel">
              <p class="userTime">{{e.date}}</p>
              <div class="hotModel" v-show="e.type == 2">
                <div class="hotModelChild"><img src="@/assets/image/icon/browse.png" alt=""><span>{{e.view_number}}</span></div>
                <div class="hotModelChild"><img src="@/assets/image/icon/reply.png" alt=""><span>{{e.comment_number}}</span></div>
                <div class="hotModelChild"><img src="@/assets/image/icon/praise.png" alt=""><span>{{e.like_number}}</span></div>
              </div>
            </div>
          </div>

          <div class="cardMod" v-if="e.source_type == 4" @click="goMessage(e.origin_resource_id)">
            <div class="header">
              <div class="userInfo">
                <div class="userImg">
                  <img :src="e.avatar" alt="" class="userHeadPortrait">
                  <img src="@/assets/image/icon/pv.png" alt="" class="userMark" v-if="e.mp_type == 1">
                  <img src="@/assets/image/icon/tv.png" alt="" class="userMark" v-if="e.mp_type == 2">
                </div>
                <p>{{e.username}}</p>
              </div>
              <img src="@/assets/image/icon/top.png" alt="" class="topIcon" v-show="e.is_recommend">
            </div>
            <div v-if="e.images.length > 0" class="messageConter aFigure">
              <div v-html="srtText(e.message)"></div>
              <img :src="e.images[0]" alt="">
            </div>
            <div v-else class="messageConter">
              <div v-html="srtText(e.message)"></div>
            </div>
            <div class="timeModel">
              <p class="userTime">{{e.createdate}}</p>
              <div class="hotModel">
                <div class="hotModelChild"><img src="@/assets/image/icon/replyIcon2.png" alt=""><span>{{e.is_recommend}}</span></div>
                <div class="hotModelChild"><img src="@/assets/image/icon/startPraise.png" alt=""><span>{{e.like_number}}</span></div>
              </div>
            </div>
          </div>
          
          <div class="cardMod" v-if="e.source_type == 5" @click="goInvitation(e.origin_resource_id)">
            <div class="userName">
              <div class="userImg">
                <img :src="e.avatar" alt="" class="userHeadPortrait">
                <img src="@/assets/image/icon/pv.png" alt="" class="userMark" v-if="e.mp_type == 1">
                <img src="@/assets/image/icon/tv.png" alt="" class="userMark" v-if="e.mp_type == 2">
              </div>
              <p>{{e.author}}</p>
            </div>
            <div class="elseTitleModel">
              <p class="userTitle">{{e.title}}</p>
              <p class="userContent">{{e.content}}</p>
            </div>
            <div class="timeModel">
              <p class="userTime">{{e.show_time}}</p>
              <div class="hotModel">
                <div class="hotModelChild"><img src="@/assets/image/icon/browse.png" alt=""><span>{{e.views}}</span></div>
                <div class="hotModelChild"><img src="@/assets/image/icon/reply.png" alt=""><span>{{e.replies}}</span></div>
                <div class="hotModelChild"><img src="@/assets/image/icon/praise.png" alt=""><span>{{e.likes}}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['userId'],

    data() {
      return {
        recommendList: [],
      }
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getTeachingList();
      },

      getTeachingList() {
        this.$http({
          url: '/renovation/initPersonRenovation',
          method: 'get',
          params: {
            master_id: this.userId,
          }
        }).then(res => {
          if (res.code >= 0) {
            this.recommendList = res.data;
            this.getListLength(res.code)
          } else {
            this.getListLength(res.code)
          }
        })
      },

      getListLength(code) {
        this.$emit('length', code)
      },
      
      goVideo(id, type){
        sessionStorage.setItem('cur', 0);
        this.$router.push({
          path: '/cFilm',
          query: {
            id: id,
            type: type,
          }
        })
      },

      goProduct(pid) {
        sessionStorage.setItem('cur', 0);
        this.$router.push({
          path: '/product',
          query: {
            pid: pid,
          }
        })
      },
      
      goCourse(id){
        sessionStorage.setItem('cur', 0);
        this.$router.push({
          path: '/elaborateCourseShare',
          query: {
            courseid: id,
          }
        })
      },
      
      goTopic(tid){
        sessionStorage.setItem('cur', 0);
        this.$router.push({
          path: '/topic',
          query: {
            tid: tid,
          }
        })
      },
      
      goTopicPost(tid){
        sessionStorage.setItem('cur', 0);
        this.$router.push({
          path: '/topicPost',
          query: {
            tid: tid,
          }
        })
      },
      
      goMessage(mid){
        sessionStorage.setItem('cur', 0);
        this.$router.push({
          path: '/aMessage',
          query: {
            mid: mid,
          }
        })
      },
      
      goInvitation(tid){
        sessionStorage.setItem('cur', 0);
        this.$router.push({
          path: '/invitation',
          query: {
            tid: tid,
          }
        })
      },
      
      srtText(data){
        let text = data.replace(/<.*?>/g, "");
        return text;
      },
    }
  }
</script>

<style lang="css" scoped>
  .recommend {
    box-sizing: border-box;
  }
  
  .typeOneCon {
    box-sizing: border-box;
    padding: 0 1.25rem;
  }

  .videoMod {
    box-sizing: border-box;
    border-bottom: .2rem solid #EEEEEE;
  }

  .modTitle {
    font-size: 1.6rem;
    color: #1D2023;
    font-weight: 600;
    padding: 0 1.25rem;
    padding-top: 2.4rem;
    background-color: #FFFFFF;
  }

  .videoDetails {
    padding: 0 1.25rem 2.4rem 1.25rem;
  }
  
  .videoCon {
    padding-bottom: .8rem;
  }

  .videoTV {
    position: relative;
    margin-top: .85rem;
    width: 100%;
    height: 17.2rem;
    border-radius: .8rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 0 50%;
  }

  .videoTitle {
    box-sizing: border-box;
    height: 4rem;
    line-height: 3rem;
    border-radius: .8rem .8rem 0 0;
    font-size: 1.2rem;
    color: #FFFFFF;
    padding: .8rem 2rem;
    background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .playBtn {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 4.2rem;
    height: 4.2rem;
    margin-top: -2.1rem;
    margin-left: -2.1rem;
  }

  .videoNum {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .iconBtn {
    margin-top: 1.4rem;
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    color: #C0C4CC;
  }

  .iconBtn img {
    width: 1.9rem;
    height: 1.9rem;
    margin-left: 1.6rem;
  }

  .iconBtn p {
    margin-left: .3rem;
  }

  .productMod {
    box-sizing: border-box;
    border-bottom: .2rem solid #EEEEEE;
  }

  .productDetails {
    padding: 0 1.25rem 2.4rem 1.25rem;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: .8rem;
  }

  .productContent {
    position: relative;
    box-sizing: border-box;
    width: 15rem;
    margin-bottom: 2rem;
  }

  .productCover {
    width: 100%;
    height: 15rem;
    object-fit: cover;
    border-radius: .5rem;
  }

  .productTitle {
    font-size: 1.4rem;
    height: 3.8rem;
    color: #1D2023;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .productTitle span {
    box-sizing: border-box;
    border-radius: .3rem;
    padding: 0 .3rem;
    font-size: 1rem;
    color: #FFFFFF;
    background: linear-gradient(to right, #FF6F6F, #F82945);
    margin-right: .5rem;
  }

  .productInfo {
    display: flex;
    justify-content: space-between;
  }

  .productView {
    display: flex;
    align-items: center;
    font-size: 1rem;
    color: #C0C4CC;
  }

  .productView img {
    width: 1.4rem;
    height: 1.4rem;
    margin-right: .5rem;
    border-radius: .5rem;
    object-fit: cover;
  }

  .productPrice {
    font-size: 1.8rem;
    color: #F7443F;
  }

  .productPrice span {
    font-size: 1rem;
  }
  
  /* 课程 */
  .courseMod {
    box-sizing: border-box;
    margin-bottom: .5rem;
    background-color: #FFFFFF;
    border-bottom: .2rem solid #EEEEEE;
  }
  
  .courseCon {
    background-color: rgba(238, 238, 238, 0.5);
    margin-top: 1.2rem;
    border-radius: 1rem;
    padding: 1rem 1.6rem;
  }
  
  .courseTitle {
    font-size: 1.4rem;
    color: #1D2023;
    font-weight: 600;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .courseTeacher {
    display: flex;
    margin-top: 1.5rem;
    justify-content: space-between;
    align-items: center;
  }
  
  .teacherHeadPortrait {
    display: flex;
    padding-left: .5rem;
  }
  
  .teacherHeadPortrait img {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    border: .1rem solid #FFFFFF;
    margin-left: -.5rem;
  }
  
  .priceBtn {
    box-sizing: border-box;
    padding: 0 1rem;
    height: 1.8rem;
    border-radius: .9rem;
    text-align: center;
    background-color: #EAEAEA;
    font-size: 1.2rem;
    color: #F7443F;
  }
  
  /* 其他 */
  .elseMod {
    background-color: #F7F8F8;
    
  }
  
  .cardMod {
    box-sizing: border-box;
    margin-bottom: .5rem;
    background-color: #FFFFFF;
    padding: 1rem 1.25rem;
  }
  
  .titleModel {
    display: flex;
    justify-content: space-between;
    margin-top: .7rem;
  }

  .titleModel img{
    width: 10rem;
    height: 6.3rem;
    margin-left: .8rem;
    border-radius: .5rem;
    object-fit: cover;
  }

  /* 话题 */
  .userName {
    display: flex;
    align-items: center;
    color: #3F454B;
    font-size: 12px;
    margin-top: 1rem;
  }

  .userImg {
    position: relative;
  }

  .userHeadPortrait {
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 50%;
  }

  .userMark {
    position: absolute;
    left: 1.5rem;
    bottom: 0;
    width: 1.2rem;
    height: 1.2rem;
  }

  .userName p {
    margin-left: .8rem;
    font-size: 1.4rem;
    color: #606972;
  }

  .timeModel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.5rem;
  }
  
  .userTitle {
    margin-bottom: 1rem;
    font-size: 1.6rem;
    color: #1D2023;
    font-weight: 600;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .userContent {
    height: 3.8rem;
    font-size: 1.4rem;
    color: #606972;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
    margin-top: .55rem;
  }

  .userTime {
    font-size: 1.2rem;
    color: #C0C4CC;
  }

  .hotModel {
    display: flex;
  }

  .hotModelChild {
    width: 6rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .hotModelChild img {
    width: 1.9rem;
  }

  .hotModelChild span {
    font-size: 1.2rem;
    color: #C0C4CC;
    margin-left: .25rem;
  }

  .hotNum {
    font-size: 1.2rem;
    color: #1D2023;
    margin-right: .5rem;
  }

  .hotTxt {
    font-size: 1.2rem;
    color: #C0C4CC;
  }
  
  /* 留言板 */
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #3F454B;
    font-size: 12px;
  }
  
  .userInfo {
    display: flex;
    align-items: center;
  }
  
  .userInfo p {
    margin-left: .8rem;
  }
  
  .userImg {
    position: relative;
  }
  
  .userHeadPortrait {
    width: 3.4rem;
    height: 3.4rem;
    border-radius: 50%;
  }
  
  .userMark {
    position: absolute;
    left: 2.2rem;
    bottom: 0;
    width: 1.2rem;
    height: 1.2rem;
  }
  
  .topIcon {
    width: 3.2rem;
    height: 1.6rem;
  }
  
  .messageConter{
    max-height: 16.8rem;
    overflow: hidden;
    font-size: 1.4rem;
    color: #1D2023;
    margin-top: .7rem;
  }
  
  .aFigure{
    display: flex;
    justify-content: space-between;
  }
  
  .aFigure div {
    width: 22.7rem;
  }
  
  .aFigure img{
    width: 10rem;
    height: 6.3rem;
    border-radius: .5rem;
    object-fit: cover;
  }
  
  
  
  .userTime{
    font-size: 1.2rem;
    color: #C0C4CC;
  }
  
  .hotModel {
    display: flex;
  }
  
  .hotModelChild {
    width: 5.6rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  
  .hotModelChild img {
    width: 2rem;
    height: 2rem;
    margin-top: .1rem;
  }
  
  .hotModelChild span{
    font-size: 1.2rem;
    color: #3F454B;
    margin-left: .25rem;
  }  
</style>
